import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Alert,
  ToggleButton,
  ToggleButtonGroup,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./login.css";
import axios from "axios";
import axiosInstance from "../../api/axios";

export default function Login({ setUser }) {
  const [loginType, setLoginType] = useState("user");
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState(""); // 단일 에러 상태
  const [loading, setLoading] = useState(false); // 로딩 상태
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = formData;

    if (!email || !password) {
      setError("아이디와 비밀번호를 입력해주세요.");
      return;
    }

    setLoading(true);
    setError(""); // 에러 초기화

    try {
      const response = await axios.post("/api/user/login/jwt", {
        email,
        password,
        loginType,
      });

      if (response.data.resultCode === "200") {
        const { accessToken } = response.data.data;

        // 로컬스토리지에 저장
        // localStorage.setItem("accessToken", accessToken);
        // localStorage.setItem("refreshToken", refreshToken);

        // 사용자 정보 가져오기
        // const userResponse = await axios.get("/api/user/detail", {
        //   headers: { Authorization: `Bearer ${accessToken}` },
        // });
        const userResponse = await axiosInstance.get("/api/user/detail");

        const user = userResponse.data.data;

        // 사용자 정보를 세션 스토리지에 저장
        sessionStorage.setItem("user", JSON.stringify(user));

        // 사용자 상태 업데이트
        setUser(user);

        // 경로 이동
        if (loginType === "ADMIN") {
          navigate("/");
        } else {
          navigate("/");
        }
      } else {
        setError(response.data.resultMessage || "로그인에 실패했습니다.");
      }
    } catch (err) {
      console.error("Login failed:", err);
      setError(
        err.response?.data?.resultMessage || "로그인 중 문제가 발생했습니다."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="login-container">
      <Row className="justify-content-center">
        <Col md={6}>
          {/* 로고 추가 */}
          <img
            src="/images/logo/logo.png"
            alt="로고"
            className="mb-3"
            style={{ maxWidth: "100%" }}
          />
          <h2 className="text-center mb-4">로그인</h2>

          {error && <Alert variant="danger">{error}</Alert>}

          <Form onSubmit={handleSubmit}>
            <ToggleButtonGroup
              type="radio"
              name="loginType"
              value={loginType}
              onChange={(val) => setLoginType(val)}
              className="mb-3 w-100"
            >
              <ToggleButton
                id="user-login"
                variant="outline-primary"
                value="user"
                style={{
                  backgroundColor:
                    loginType === "user" ? "#1769b3" : "transparent",
                  color: loginType === "user" ? "white" : "#1769b3",
                  borderColor: "#1769b3",
                }}
              >
                사용자 로그인
              </ToggleButton>
              <ToggleButton
                id="admin-login"
                variant="outline-secondary"
                value="ADMIN"
              >
                관리자 로그인
              </ToggleButton>
            </ToggleButtonGroup>

            <Form.Group className="mb-3" controlId="formUsername">
              <Form.Label>아이디</Form.Label>
              <Form.Control
                type="text"
                placeholder="아이디를 입력하세요"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formPassword">
              <Form.Label>비밀번호</Form.Label>
              <Form.Control
                type="password"
                placeholder="비밀번호를 입력하세요"
                name="password"
                value={formData.password}
                onChange={handleChange}
              />
            </Form.Group>

            <Button
              style={{
                backgroundColor: "#1769b3",
                borderColor: "#1769b3",
                color: "white",
              }}
              type="submit"
              className="w-100 mb-3"
              disabled={loading}
            >
              {loading ? "로그인 중..." : "로그인"}
            </Button>

            {/* 홈으로 돌아가기 및 회원가입 버튼 */}
            <div className="d-flex justify-content-between">
              <Button variant="outline-secondary" onClick={() => navigate("/")}>
                홈으로 돌아가기
              </Button>
              <Button
                style={{
                  borderColor: "#1769b3",
                  color: "#1769b3",
                  backgroundColor: "transparent",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#1769b3";
                  e.target.style.color = "#ffffff";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#1769b3";
                }}
                onClick={() => navigate("/register")}
              >
                회원가입
              </Button>
            </div>
          </Form>

          {/* 회원가입 안내 메시지 */}
          <div className="signup-prompt text-center mt-4">
            <p>
              처음이신가요?{" "}
              <Button
                variant="link"
                className="p-0"
                onClick={() => navigate("/register")}
              >
                회원가입
              </Button>
              을 해보세요!
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
